import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";

interface AuthRequiredModalProps {
  authRequiredModalOpen: boolean;
  setAuthRequiredModalOpen: (open: boolean) => void;
  triggerLogin: () => void;
}

const AuthRequiredModal: React.FC<AuthRequiredModalProps> = ({
  authRequiredModalOpen,
  setAuthRequiredModalOpen,
  triggerLogin,
}) => {
  const closeModal = () => {
    setAuthRequiredModalOpen(false);
  };

  const confirmModal = () => {
    setAuthRequiredModalOpen(false);
    triggerLogin();
  };

  return (
    <Dialog
      open={authRequiredModalOpen}
      onClose={closeModal}
      aria-labelledby="auth-required-title"
      disableEscapeKeyDown
    >
      <DialogTitle id="auth-required-title">Authentication Required</DialogTitle>
      <DialogContent>
        <Typography variant="body1">Do you want to re-authenticate?</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeModal} color="secondary">
          No
        </Button>
        <Button onClick={confirmModal} color="primary" variant="contained">
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AuthRequiredModal;
